import { Card, CardHeader, IconButton, Stack, Tooltip } from "@mui/material"
import DashboardLayout from "../../layoutcontainers/DashboardLayout"
import MaterialBox from "../../components/MaterialBox"
import { useUserDetails } from "../../context/auth";
import { Add, Delete, Edit, PictureAsPdf, Visibility } from "@mui/icons-material";
import { useEffect, useState } from "react";
import MaterialButton from "../../components/MaterialButton";
import MaterialTypography from "../../components/MaterialTypography";
import MaterialDataGrid from "../../components/MaterialDataGrid";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import axios from "axios";
import BASEURL from "../Utils/Baseurl";
import { getAllOnboardingLetterQuery, deleteEmployeeOnboardingLetterQuery } from "./components/Queries";

const AppointmentLetterList = () => {

    const navigate = useNavigate();
    const { AccessData } = useUserDetails();
    const [isLoading, setIsLoading] = useState(false);
    const [appointmentLetters, setAppointmentLetters] = useState([]);

    useEffect(() => {
        getAppointmentLetters();
    },[])

    const getAppointmentLetters = async () => {
        setIsLoading(true);
        try {
            const response = await axios.post(
                BASEURL,
                {
                    query: getAllOnboardingLetterQuery,
                },
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            );

            const result =
                response.data?.data?.employeeOnboardLetterByAll;

            if (result?.success) {
                setAppointmentLetters(result?.data || []);
            } else {

                Swal.fire({
                    position: "center",
                    icon: "error",
                    title:
                        result?.message ||
                        "Failed to fetch offer letters",
                    showConfirmButton: false,
                    timer: 2500,
                });

                return [];
            }
        } catch (error) {
            console.error("Error fetching employee offer letters:",error);

            Swal.fire({
                position: "center",
                icon: "error",
                title:
                    error?.response?.data?.errors?.[0]?.message ||
                    error?.message ||
                    "Failed to fetch offer letters",
                showConfirmButton: false,
                timer: 2500,
            });

            return [];
        }finally{
            setIsLoading(false);
        }
    };

    const handleDeleteAppointment = async (id, title) => {        
        
        const confirmResult = await Swal.fire({
            title: "Are you sure?",
            text: `Do you want to delete ${title || "this offer letter"}?`,
            icon: "warning",
            showCancelButton: true,
            cancelButtonText: "Cancel",
            confirmButtonText: "Yes, delete it!",
        });

        if (!confirmResult.isConfirmed) {
            return;
        }

        try {
            const response = await axios.post(
                BASEURL,
                {
                    query: deleteEmployeeOnboardingLetterQuery,
                    variables: {
                        id: id,
                    },
                },
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            );

            const result =
                response.data?.data?.deleteEmployeeOnboardLetter;

            if (result?.success) {
                await Swal.fire({
                    position: "center",
                    icon: "success",
                    title: result?.message || "Deleted successfully",
                    showConfirmButton: false,
                    timer: 2000,
                });

                // Refresh your list here
                getAppointmentLetters();
            } else {
                Swal.fire({
                    position: "center",
                    icon: "error",
                    title: result?.message || "Failed to delete offer letter",
                    showConfirmButton: false,
                    timer: 2500,
                });
            }
        } catch (error) {
            console.error("Error deleting offer letter:", error);

            Swal.fire({
                position: "center",
                icon: "error",
                title:
                    error?.response?.data?.errors?.[0]?.message ||
                    error?.message ||
                    "Failed to delete offer letter",
                showConfirmButton: false,
                timer: 2500,
            });
        }
    }

    const handleFormNavigate = () => {
        navigate("/appointment-letter/appointment-Letter-Form");
    };

    const onboardListTablleData = {
            columns: [
                {
                    field: "sno",
                    headerName: "S.No.",
                    flex: 0.3,
                    editable: false,
                    disableColumnMenu: true,
                    sortable: true,
                },
                {
                    field: "empId",
                    headerName: "Employee ID",
                    flex: 0.6,
                    editable: false,
                    disableColumnMenu: true,
                    sortable: true,
                },
                {
                    field: "fullName",
                    headerName: "Full Name",
                    flex: 1.2,
                    editable: false,
                    disableColumnMenu: true,
                    sortable: true,
                },
                {
                    field: "department",
                    headerName: "Department",
                    flex: 0.7,
                    editable: false,
                    disableColumnMenu: true,
                    sortable: true,
                },
                {
                    field: "designation",
                    headerName: "Designation",
                    flex: 0.9,
                    editable: false,
                    disableColumnMenu: true,
                    sortable: true,
                },
                {
                    field: "doj",
                    headerName: "Date of Joining",
                    flex: 0.7,
                    editable: false,
                    disableColumnMenu: true,
                    sortable: true,
                },
                {
                    field: "createdOn",
                    headerName: "Created On",
                    flex: 0.6,
                    editable: false,
                    disableColumnMenu: true,
                    sortable: true,
                },
                {
                    headerName: "Action",
                    field: "action",
                    name: "Action",
                    flex: 0.6,
                    disableColumnMenu: true,
                    editable: false,
                },
            ],
            rows: (appointmentLetters || []).map((value, i) => ({
              id: value.id,
              sno: i + 1,
              fullName: value?.fullName,
              empId: value?.empId,
              department: value?.department,
              designation: value?.designation,
              doj: value?.doj,
              createdOn: new Date(value?.createdAt).toLocaleDateString("en-CA"),              
              action: (
                <MaterialBox
                    sx={{
                    display: "flex",
                    alignItems: "center",
                    width: "100%",
                    height: "100%",
                    }}
                >
                    {AccessData &&
                    Array.isArray(AccessData) &&
                    AccessData.some(
                        (item) => item.module === "Procedure" && item.component === "ViewProcedure" && item.can_access
                    ) && (
                        <Tooltip
                        title="View"
                        placement="top"
                        disableInteractive
                        onClick={() => navigate(`/appointment-letter/appointment-Letter-Form?mode=view&id=${value?.id}`)}
                        >
                        <IconButton size="small">
                            <Visibility />
                        </IconButton>
                        </Tooltip>
                    )}
                    {AccessData &&
                    Array.isArray(AccessData) &&
                    AccessData.some(
                        (item) => item.module === "Procedure" && item.component === "ViewProcedure" && item.can_access
                    ) && (
                        <Tooltip
                        onClick={() => navigate(`/appointment-letter/appointment-pdf?id=${value?.id}`)}
                        title="View PDF"
                        placement="top"
                        disableInteractive
                        >
                        <IconButton size="small">
                            <PictureAsPdf />
                        </IconButton>
                        </Tooltip>
                    )} 
                    {AccessData &&
                    Array.isArray(AccessData) &&
                    AccessData.some(
                        (item) => item.module === "Procedure" && item.component === "EditProcedure" && item.can_access
                    ) && (
                        <Tooltip
                        title="Edit"
                        placement="top"
                        disableInteractive
                        onClick={() => navigate(`/appointment-letter/appointment-Letter-Form?mode=edit&id=${value?.id}`)}
                        >
                        <IconButton size="small">
                            <Edit />
                        </IconButton>
                        </Tooltip>
                    )}
                    {AccessData &&
                    Array.isArray(AccessData) &&
                    AccessData.some(
                        (item) => item.module === "Procedure" && item.component === "EditProcedure" && item.can_access
                    ) && (
                        <Tooltip
                        onClick={() => handleDeleteAppointment(value?.id, value?.fullName)}
                        title="Delete"
                        placement="top"
                        disableInteractive
                        >
                        <IconButton size="small">
                            <Delete />
                        </IconButton>
                        </Tooltip>
                    )}                                        
                </MaterialBox>
              ),
          })),
        };
  return (
    <DashboardLayout>
        <Card>
            <CardHeader
                sx={{
                    p: 2,
                    pb: 1,
                }}
                title={
                    <Stack
                        direction="row"
                        alignItems="flex-start"
                        justifyContent="space-between"
                        sx={{
                            width: "100%",
                        }}
                    >
                        <Stack direction="column" spacing={0}>
                            <MaterialTypography variant="h5" fontWeight="medium">
                                Appointment Letter List
                            </MaterialTypography>

                            <MaterialTypography variant="caption" fontWeight="medium">
                                List of appointment letters uploaded directly
                            </MaterialTypography>
                        </Stack>

                        {AccessData &&
                            Array.isArray(AccessData) &&
                            AccessData.some(
                                (item) =>
                                    item.module === "Procedure" &&
                                    item.component === "AddProcedure" &&
                                    item.can_access
                            ) && (
                                <MaterialBox sx={{ ml: "auto" }}>
                                    <MaterialButton
                                        variant="gradient"
                                        color="dark"
                                        size="small"
                                        startIcon={<Add />}
                                        onClick={handleFormNavigate}
                                    >
                                        Appointment
                                    </MaterialButton>
                                </MaterialBox>
                            )}
                    </Stack>
                }
            />

            <MaterialDataGrid
                rows={onboardListTablleData.rows}
                columns={onboardListTablleData.columns}
                loading={isLoading}
                noSearch={false}
                localeText={{
                noRowsLabel: (
                    <Stack
                    direction="column"
                    alignItems="center"
                    justifyContent="center"
                    spacing={1}
                    >
                    <MaterialTypography
                        variant="body2"
                        fontWeight="medium"
                        color="text"
                    >
                        {"No Appointments Uploaded yet"}
                    </MaterialTypography>
                    </Stack>
                ),
                }}
            />
        </Card>
    </DashboardLayout>
  )
}

export default AppointmentLetterList